import $ from "jquery";

class AccountSelectors {
    constructor(element) {
        this.div = element;

        this.bindEvents();
    }

    bindEvents() {
        var _thisAccountSelectors = this;
        $(this.div).on('change', function () {
            _thisAccountSelectors.updateClass(this, event);
        });
    }
    updateClass(selector, event) {
        event.preventDefault();

        if (selector.selectedIndex >= 1) {
            $(selector).removeClass('is-empty');
        } else {
            $(selector).addClass('is-empty');
        }

    }
}

export default AccountSelectors;